import type { ITableSort } from "app/components/React/Table/types";
import type { ISortDirection } from "app/@types/userdata";

export const sortByProperty =
    (property: string) =>
    (array: Record<string, any>, isDescending = false) => {
        const sortedArray = array.sort((a: any, b: any) => a[property] - b[property]);
        return isDescending ? sortedArray.reverse() : sortedArray;
    };

export const shuffle = (array: any[]) => array.sort(() => (Math.random() > 0.5 ? -1 : 1));

export const invertSortDirection = (direction: ISortDirection) => {
    switch (direction) {
        case "asc":
            return "desc";
        case "desc":
            return "asc";
        default:
            return direction;
    }
};

const getIndexForObjectArray = (otherArray: readonly any[], that: any, other: any, sortProperty: string) => {
    const thatIndex = otherArray.findIndex((item) => item[sortProperty] === that[sortProperty]);
    const otherIndex = otherArray.findIndex((item) => item[sortProperty] === other[sortProperty]);
    return { thatIndex, otherIndex };
};

const getIndex = (otherArray: readonly any[], that: any, other: any) => {
    const thatIndex = otherArray.indexOf(that);
    const otherIndex = otherArray.indexOf(other);
    return { thatIndex, otherIndex };
};

export const sortArrayAsOtherArray = (array: Array<any>, otherArray: Array<any>, sortProperty?: string) => {
    const sortedArray = array.sort((that, other) => {
        const { thatIndex, otherIndex } = sortProperty
            ? getIndexForObjectArray(otherArray, that, other, sortProperty)
            : getIndex(otherArray, that, other);
        if (otherIndex < 0) return 1;
        return thatIndex - otherIndex;
    });
    return sortedArray;
};

export const recordsSorterHof = (sort: ITableSort) => {
    return (record: Record<string, any>, otherRecord: Record<string, any>): number => {
        const { field, sortDirection } = sort;
        let results;
        const value = record[field];
        if (typeof value === "string") {
            const otherValue = otherRecord[field] as string;
            results = value.localeCompare(otherValue);
        } else {
            results = (value as number) > (otherRecord[field] as number) ? 1 : -1;
        }
        // == to catch both null and undefined
        if (value == null) {
            results = sortDirection === "asc" ? 1 : -1;
        }
        if (otherRecord[field] == null) {
            results = sortDirection === "asc" ? -1 : 1;
        }
        return sortDirection === "asc" ? results : -1 * results;
    };
};
